import React from 'react';
import { IconBase } from '../Base';
export const IconTick = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M6 9.75L8.66667 12.5L14 7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Tick.js.map